const state = {};
const mutations = {};
const actions = {
    success(_context, message) {
        window.app.$notify({
            timeout: 5000,
            message: message,
            horizontalAlign: "right",
            verticalAlign: "top",
            icon: "add_alert",
            type: "success",
            isNoti: true,
        });
    },
    error(_context, message) {
        window.app.$notify({
            timeout: 7000,
            message: message,
            horizontalAlign: "right",
            verticalAlign: "top",
            icon: "add_alert",
            type: "warning",
            isNoti: true,
        });
    },
    firebaseNotification(_context, firebaseContent) {
        window.app.$notify({
            timeout: 7000,
            message: '',
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "info",
            isFirebaseNoti: true,
            firebaseNotiContent: firebaseContent
        });
    },
    chatNoti(_context, chatContent) {
        window.app.$notify({
            timeout: 7000,
            message: '',
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "info",
            isChatNoti: true,
            chatContent: chatContent
        });
    },
    chatNotiReaction(_context, chatContent) {
        window.app.$notify({
            timeout: 7000,
            message: '',
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "info",
            isChatNotiReaction: true,
            chatContent: chatContent
        });
    }
};
const getters = {};
const alerts = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default alerts;
